// src/pages/AppOrdenPagoReactTable.jsx
import React, { useState, useEffect, useMemo, useCallback } from "react";
import styled from "styled-components";
import { useFilters, useSortBy, usePagination } from "react-table";
import moment from "moment";
import Table from "../components/TableContainer";

// 👉 vas a necesitar este modal (igual al de OC pero para OP)
// si aún no lo tenés, dejalo importado y luego lo creamos igual al de cobro.
import ModalVerOrdenPago from "../components/ModalVerOrdenPago";

import {
  listOrdenesPago,
  anularOrdenPago,
} from "../helpers/rutaOrdenesPago";
import { generarPDFOrdenPago } from "../helpers/pdfOrdenPago";

const EMAIL_PUEDE_ANULAR_OP = "pablonsaya@hotmail.com";

const parseJSONSafe = (value) => {
  try {
    return value ? JSON.parse(value) : null;
  } catch (_) {
    return null;
  }
};

const getUsuarioActual = () => {
  const posiblesKeys = ["usuario", "user", "usuarioLogueado", "currentUser"];

  for (const key of posiblesKeys) {
    const obj = parseJSONSafe(localStorage.getItem(key));
    if (obj?.email || obj?.correo || obj?.usuario?.email || obj?.user?.email) {
      return obj;
    }
  }

  try {
    const token = localStorage.getItem("token") || "";
    const payload = token.split(".")[1];
    if (!payload) return null;

    const base64 = payload.replace(/-/g, "+").replace(/_/g, "/");
    const padded = base64.padEnd(
      base64.length + ((4 - (base64.length % 4)) % 4),
      "="
    );

    const decoded = JSON.parse(window.atob(padded));
    return decoded?.usuario || decoded?.user || decoded;
  } catch (_) {
    return null;
  }
};

const getEmailUsuario = (u) =>
  String(
    u?.email ||
      u?.correo ||
      u?.usuario?.email ||
      u?.user?.email ||
      ""
  )
    .toLowerCase()
    .trim();

const Styles = styled.div`
  .table-container { overflow: auto; height: 600px; }
  .table-container table {
    border: 1px solid black;
    border-spacing: 0;
    font-size: 13px;
    table-layout: fixed;
    width: max-content;
  }
  th, td {
    padding: 0.5rem;
    border-bottom: 1px solid black;
    border-right: 1px solid black;
    white-space: nowrap;
  }
  th {
    background-color: #778899;
    position: sticky; top: 0; z-index: 2;
    text-align: center; font-size: 12px;
  }
  td { background-color: white; }
  .pagination { padding: 0.5rem; background-color: #778899; font-size: 15px; font-weight: bold; }

  /* Orden de columnas:
     1 Ver | 2 PDF | 3 Anular | 4 N° OP | 5 Fecha | 6 Tercero | 7 Cliente | 8 ΣAplic | 9 ΣPagos | 10 ΣRets | 11 ΣNeto | 12 Estado
  */

  .table-container table th:nth-child(1),
  .table-container table td:nth-child(1),
  .table-container table th:nth-child(2),
  .table-container table td:nth-child(2),
  .table-container table th:nth-child(3),
  .table-container table td:nth-child(3) {
    width: 65px;
    min-width: 65px;
    text-align: center;
  }

  .table-container table th:nth-child(4),
  .table-container table td:nth-child(4) { width: 120px; min-width: 120px; }

   .table-container table th:nth-child(5),
  .table-container table td:nth-child(5) { width: 100px; min-width: 100px; }

  .table-container table th:nth-child(6),
  .table-container table td:nth-child(6) { width: 220px; min-width: 220px; }

  .table-container table th:nth-child(7),
  .table-container table td:nth-child(7) { width: 150px; min-width: 150px; }

  .table-container table th:nth-child(8),
  .table-container table td:nth-child(8),
  .table-container table th:nth-child(9),
  .table-container table td:nth-child(9),
  .table-container table th:nth-child(10),
  .table-container table td:nth-child(10),
  .table-container table th:nth-child(11),
  .table-container table td:nth-child(11) {
    width: 140px; min-width: 140px; text-align: right;
  }
`;

const OrdenPagoHeader = styled.div`
  display: flex;
  align-items: center;

  min-height: 78px;

  margin-bottom: 12px;

  padding: 14px 18px;

  border: 1px solid #dce5f0;
  border-radius: 14px;

  background:
    linear-gradient(
      120deg,
      #ffffff 0%,
      #f8fafc 65%,
      #eef4fb 100%
    );

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  .header-icon {
    width: 46px;
    height: 46px;

    flex: 0 0 46px;

    display: flex;
    align-items: center;
    justify-content: center;

    margin-right: 13px;

    border-radius: 11px;

    background: #eaf2ff;

    color: #2868c6;

    font-size: 19px;
  }

  .header-text span {
    display: block;

    margin-bottom: 2px;

    color: #5f7fa8;

    font-size: 9px;
    font-weight: 700;

    letter-spacing: 1.7px;
  }

  .header-text h3 {
    margin: 0 0 3px 0;

    color: #18243a;

    font-size: 20px;
    font-weight: 700;
  }

  .header-text p {
    margin: 0;

    color: #748196;

    font-size: 10px;
  }
`;

const OrdenPagoFiltros = styled.div`
  display: flex;
  align-items: end;

  gap: 8px;

  flex-wrap: wrap;

  margin-bottom: 12px;

  padding: 14px;

  border: 1px solid #e2e8f0;
  border-radius: 12px;

  background: #ffffff;

  box-shadow:
    0 3px 14px
    rgba(15, 23, 42, 0.035);

  .op-field {
    display: flex;
    flex-direction: column;

    gap: 5px;
  }

  .op-field label {
    margin: 0;

    color: #59687d;

    font-size: 10px;
    font-weight: 600;
  }

  .op-field input,
  .op-field select {
    height: 34px;

    padding: 0 8px;

    border: 1px solid #d7e0ea;
    border-radius: 7px;

    background: #ffffff;

    color: #24324a;

    font-size: 10.5px;
  }

  .op-date {
    width: 150px;
  }

  .op-state {
    width: 145px;
  }

  .op-actions {
    display: flex;

    gap: 6px;

    flex-wrap: wrap;
  }

  .op-actions button {
    min-height: 34px;

    padding: 5px 11px;

    border-radius: 7px;

    font-size: 10px;
    font-weight: 600;

    white-space: nowrap;
  }

  @media (max-width: 768px) {
    .op-field,
    .op-date,
    .op-state {
      width: 100%;
    }

    .op-actions {
      width: 100%;
    }
  }
`;

export default function AppOrdenPagoReactTable() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  // filtros
  const [desde, setDesde] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [hasta, setHasta] = useState(moment().format("YYYY-MM-DD"));
  const [estado, setEstado] = useState(""); // "", "EMITIDA", "ANULADA"

  // visor OP
  const [showVerOP, setShowVerOP] = useState(false);
  const [verOpId, setVerOpId] = useState(null);

  const puedeAnularOP = useMemo(() => {
    const usuario = getUsuarioActual();
    const email = getEmailUsuario(usuario);
    return email === EMAIL_PUEDE_ANULAR_OP;
  }, []);

  const money = (n) =>
    (Number(n || 0)).toLocaleString("es-AR", { style: "currency", currency: "ARS" });

  const fetchData = useCallback(async () => {
    setLoading(true);
    // el back acepta desde/hasta (y opcional tercero/cliente). No acepta estado por query.
    const resp = await listOrdenesPago({ desde, hasta });
    if (!resp?.ok) {
      console.error(resp?.msg || resp?.error || "Error al listar OP");
      setData([]);
    } else {
      let ordenes = resp.ordenes || [];
      // filtro de estado en frontend para no tocar el back
      if (estado) {
        const expected = estado.toLowerCase(); // "emitida" | "anulada"
        ordenes = ordenes.filter(op => (op.estado || "").toLowerCase() === expected);
      }
      setData(ordenes);
    }
    setLoading(false);
  }, [desde, hasta, estado]);

  useEffect(() => { fetchData(); }, [fetchData]);

  const onAnular = useCallback(async (id) => {
    try {
      if (
        !window.confirm(
          "¿Anular esta Orden de Pago? Esto revierte aplicaciones, movimientos, caja/banco y cartera si corresponde."
        )
      ) {
        return;
      }

      const r = await anularOrdenPago(id);

      if (r?.ok) {
        alert("Orden de pago anulada.");
        fetchData();
      } else {
        alert(r?.msg || r?.error || r?.err || "No se pudo anular la orden.");
      }
    } catch (error) {
      console.error("Error anulando OP:", error);
      alert(error?.message || "Error inesperado anulando la orden.");
    }
  }, [fetchData]);

  // utilidades por N° OP-AAAA-####
  const findByNumeroYAbrir = async (imprimir = false) => {
    const nro = prompt("N° de Orden de Pago (ej: OP-2025-0007):");
    if (!nro) return;

    // Busco en un rango amplio (puede ajustarse si querés limitar)
    const r = await listOrdenesPago({});
    if (!r?.ok) return alert(r?.msg || "Error buscando órdenes.");

    const found = (r.ordenes || []).find(x => (x.numero || "").trim().toUpperCase() === nro.trim().toUpperCase());
    if (!found) return alert("No se encontró la Orden de Pago.");

    if (imprimir) {
      generarPDFOrdenPago(found._id);
    } else {
      setVerOpId(found._id);
      setShowVerOP(true);
    }
  };

  const columns = useMemo(() => [
    {
      id: "ver",
      Header: "Ver",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          type="button"
          className="action-btn action-btn--edit"
          title="Ver / Editar"
          onClick={() => { setVerOpId(row.original._id); setShowVerOP(true); }}
        >
          <i className="fa fa-eye" aria-hidden="true" />
        </button>
      ),
    },
    {
      id: "pdf",
      Header: "PDF",
      accessor: "_id",
      width: 50,
      Cell: ({ row }) => (
        <button
          type="button"
          className="action-btn action-btn--pdf"
          title="Generar PDF"
          onClick={() => generarPDFOrdenPago(row.original._id)}
        >
          <i className="fa fa-file-pdf-o" aria-hidden="true" />
        </button>
      ),
    },

    {
      id: "anular",
      Header: puedeAnularOP ? "Anular" : "",
      accessor: "_id",
      width: 65,
      Cell: ({ row }) => {
        if (!puedeAnularOP) return null;

        return (
          <button
            type="button"
            className="action-btn action-btn--del"
            title="Anular OP"
            disabled={(row.original.estado || "").toLowerCase() === "anulada"}
            onClick={(e) => {
              e.preventDefault();
              e.stopPropagation();
              onAnular(row.original._id);
            }}
          >
            <i className="fa fa-ban" aria-hidden="true" />
          </button>
        );
      },
    },

    { Header: "N° OP", accessor: "numero", width: 120 },

    {
      Header: "Fecha",
      accessor: (r) => (r.fecha ? new Date(r.fecha) : ""),
      id: "fecha",
      width: 110,
      Cell: ({ value }) =>
        value instanceof Date ? value.toLocaleDateString("es-AR") : "-",
    },

    { Header: "Tercero", accessor: "tercero.transporte", width: 200 },
    // { Header: "Cliente", accessor: "cliente.razonsocial", width: 100 },

    {
      Header: () => <div style={{ textAlign: "center" }}>Σ Aplicado</div>,
      accessor: (r) => r?.totales?.aplicado ?? 0,
      id: "aplicado",
      width: 100,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{money(value)}</div>
      ),
      Footer: ({ rows }) => {
        const t = rows.reduce((s, r) => s + (r.values.aplicado || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "red" }}>
            {money(t)}
          </div>
        );
      },
    },
    {
      Header: () => <div style={{ textAlign: "center" }}>Σ Pagos</div>,
      accessor: (r) => (Array.isArray(r.pagos) ? r.pagos.reduce((a, m) => a + Number(m.importe || 0), 0) : 0),
      id: "pagos",
      width: 140,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{money(value)}</div>
      ),
      Footer: ({ rows }) => {
        const t = rows.reduce((s, r) => s + (r.values.pagos || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "blue" }}>
            {money(t)}
          </div>
        );
      },
    },
    {
      Header: () => <div style={{ textAlign: "center" }}>Σ Retenciones</div>,
      accessor: (r) => (Array.isArray(r.retenciones) ? r.retenciones.reduce((a, m) => a + Number(m.importe || 0), 0) : 0),
      id: "retenciones",
      width: 140,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{money(value)}</div>
      ),
      Footer: ({ rows }) => {
        const t = rows.reduce((s, r) => s + (r.values.retenciones || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "green" }}>
            {money(t)}
          </div>
        );
      },
    },
    {
      Header: () => <div style={{ textAlign: "center" }}>Σ Neto</div>,
      accessor: (r) => r?.totales?.netoPagado ?? 0,
      id: "neto",
      width: 140,
      Cell: ({ value }) => (
        <div style={{ textAlign: "right" }}>{money(value)}</div>
      ),
      Footer: ({ rows }) => {
        const t = rows.reduce((s, r) => s + (r.values.neto || 0), 0);
        return (
          <div style={{ textAlign: "right", fontWeight: "bold", color: "#333" }}>
            {money(t)}
          </div>
        );
      },
    },

    { Header: () => <div style={{ textAlign: "center" }}>Estado</div>,
    accessor: "estado", width: 100 },
  ], [onAnular, puedeAnularOP]);

  return (
    <div className="container mt-4">

      <OrdenPagoHeader>
        <div className="header-icon">
          <i
            className="fa fa-university"
            aria-hidden="true"
          />
        </div>

        <div className="header-text">
          <span>
            INFORMES
          </span>

          <h3>
            Órdenes de Pago
          </h3>

          <p>
            Consulta, control, impresión y
            seguimiento de órdenes de pago.
          </p>
        </div>
      </OrdenPagoHeader>

      <OrdenPagoFiltros>

        <div className="op-field op-date">
          <label>Fecha desde</label>

          <input
            type="date"
            value={desde}
            onChange={(e) =>
              setDesde(e.target.value)
            }
          />
        </div>

        <div className="op-field op-date">
          <label>Fecha hasta</label>

          <input
            type="date"
            value={hasta}
            onChange={(e) =>
              setHasta(e.target.value)
            }
          />
        </div>

        <div className="op-field op-state">
          <label>Estado</label>

          <select
            value={estado}
            onChange={(e) =>
              setEstado(e.target.value)
            }
          >
            <option value="">
              Todos
            </option>

            <option value="EMITIDA">
              Emitida
            </option>

            <option value="ANULADA">
              Anulada
            </option>
          </select>
        </div>

        <div className="op-actions">
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={fetchData}
          >
            <i className="fa fa-search mr-1" />
            Buscar
          </button>

          <button
            type="button"
            className="btn btn-outline-secondary btn-sm"
            onClick={() =>
              findByNumeroYAbrir(false)
            }
          >
            <i className="fa fa-eye mr-1" />
            Ver/Editar por N°
          </button>

          <button
            type="button"
            className="btn btn-outline-success btn-sm"
            onClick={() =>
              findByNumeroYAbrir(true)
            }
          >
            <i className="fa fa-print mr-1" />
            Imprimir por N°
          </button>
        </div>

      </OrdenPagoFiltros>

      <Styles>
        <div className="table-container">
          <Table
            columns={columns}
            data={data}
            loading={loading}
            plugins={[useFilters, useSortBy, usePagination]}
          />
        </div>
      </Styles>

      {showVerOP && verOpId && (
        <ModalVerOrdenPago
          show={showVerOP}
          opId={verOpId}
          onHide={(refrescar) => {
            setShowVerOP(false);
            setVerOpId(null);
            if (refrescar) fetchData();
          }}
        />
      )}
    </div>
  );
}
